import { AssetPreview } from '@anytag/app';
import { PartialRouter } from '../../types';

export const AssetPreviewRouter = {
  '/_private-routes/asset-preview': [AssetPreview, {}]
} as const satisfies PartialRouter;
